export var BayHeadingEnum;
(function (BayHeadingEnum) {
    BayHeadingEnum["tradingSiteDescription"] = "Trading site description";
    BayHeadingEnum["tradingSiteTown"] = "Trading site town";
    BayHeadingEnum["tradingSiteStatus"] = "Trading site status";
    BayHeadingEnum["sgCode"] = "SgCode";
    BayHeadingEnum["size"] = "Size";
    BayHeadingEnum["status"] = "Status";
})(BayHeadingEnum || (BayHeadingEnum = {}));
export var BaySearchOption;
(function (BaySearchOption) {
    BaySearchOption["Bay"] = "Bay";
})(BaySearchOption || (BaySearchOption = {}));
